module.exports = __webpack_public_path__ + "img/bg_security_gate.64e0c5a1.jpg";